import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Custom-domain mode: HostGate sets window.__CUSTOM_STORE_SLUG__ before rendering the
// storefront on an agent's own domain — all API calls must then stay same-origin (/api)
// so the agent's domain serves everything and sessions/cookies work per domain.
api.interceptors.request.use((config) => {
  if (typeof window !== "undefined" && window.__CUSTOM_STORE_SLUG__) {
    config.baseURL = "/api";
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        const refreshBase = (typeof window !== "undefined" && window.__CUSTOM_STORE_SLUG__) ? "/api" : API;
        await axios.post(`${refreshBase}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export const fmtINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export function imgUrl(u) {
  if (!u) return "";
  if (u.startsWith("/api")) return (typeof window !== "undefined" && window.__CUSTOM_STORE_SLUG__ ? "" : BACKEND) + u;
  return u;
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" }) + ", " + d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
};
